<div
  class="fixed right-4 top-4 z-[9999] flex w-[calc(100%-2rem)] max-w-sm flex-col gap-3"
>
  @for (n of (notifications.items$ | async) ?? []; track n.id) {
    <app-notification [item]="n" (close)="dismiss($event)"></app-notification>
  }
</div>
